import React from 'react';
import { Modal } from 'bootstrap';
import HfKendoComboBox from "../shared/HfKendoComboBox";
import CodeTableRow from './CodeTableRow';
import Api from '../../services/api/api';

export default class CodeTablePanel extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            codeSelection: null
        };

        this.addCodeModal = null;
        this.addCodeModalRef = React.createRef();
        this.addCodeModalInitFieldRef = React.createRef();
        this.addCodeModalForm = React.createRef();

        this.chooseAdminCodeModal = null;
        this.chooseAdminCodeModalRef = React.createRef();
    }

    componentDidMount() {
        this.addCodeModal = Modal.getOrCreateInstance(this.addCodeModalRef.current);
        this.addCodeModalRef.current.addEventListener('shown.bs.modal', (e) => {
            const field = document.querySelector('#addCodeComboBox');
            field.focus();
        });

        this.chooseAdminCodeModal = Modal.getOrCreateInstance(this.chooseAdminCodeModalRef.current);
    }

    showAddCodeModal = () => {
        this.addCodeModal.show();
    }

    hideAddCodeModal = (e) => {
        this.addCodeModal.hide();
        this.addCodeModalInitFieldRef.current.reset();
    }

    showChooseAdminCodeModal = () => {
        this.chooseAdminCodeModal.show();
    }

    hideChooseAdminCodeModal = (e) => {
        this.chooseAdminCodeModal.hide();
    }

    handleCodeSelectionChange = (e) => {
        this.setState({
            codeSelection: e.value
        });
    }

    handleCodeUnitsChange = (code, value) => {
        this.props.onCodeUnitsChange(code, value);
    }

    handleCodeDelete = (index) => {
        this.props.onCodeDelete(index);
    }

    handleCodeAdd = () => {
        if (this.state.codeSelection?.AdminCodes?.split(',')?.length >= 2) {
            // Display the Admin code modal if there are multiple admin codes
            this.showChooseAdminCodeModal();
        } else {
            this.processCode(this.state.codeSelection);
        }
    }

    handleAdminCodeAdd = (e) => {
        const adminCode = e.target.value;

        // Transform the codeSelection entry based on selected Admin code
        const codeSelection = { ...this.state.codeSelection, AdminCodes: adminCode };
        this.processCode(codeSelection);
    }

    processCode(codeData) {
        this.props.onCodeAdd(codeData);

        // Reset state
        this.setState({ codeSelection: null });
        this.hideAddCodeModal();
        this.hideChooseAdminCodeModal();
    }

    render() {
        // Turn our codeList into a series of CodeTableRow components
        const rows = this.props.codeList.map((row, i) =>
            <CodeTableRow key={i}
                code={row.code}
                name={row.name}
                units={row.units}
                cost={row.chargeAmount}
                allowables={row.altAmount}
                wrvu={row.wrvu}
                onCodeUnitsChange={this.handleCodeUnitsChange}
                onCodeDelete={this.handleCodeDelete}
                index={i}
                parent={row.parent}
            />);

        const adminCodeButtons = this.state.codeSelection?.AdminCodes?.split(',')?.map((code, i) =>
            <div key={i} className="form-group">
                <div className="col-sm-10 col-sm-offset-1">
                    <button type="button" className="btn btn-secondary" value={code} onClick={this.handleAdminCodeAdd}>{code}</button>
                </div>
            </div>) || [];

        let adminCodeComment;
        if (this.state.codeSelection?.Comment) {
            adminCodeComment = <div className="form-group">
                <div className="col-sm-10 col-sm-offset-1">
                    Note: {this.state.codeSelection.Comment}
                </div>
            </div>;
        }

        return (
            <div id={this.props.id} className="card shadow">
                <div className="card-body">
                    <div className="row">
                        <div className="col">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th className="col-sm-3">Code</th>
                                        <th className="col-sm-5">Procedure</th>
                                        <th className="col-sm-2">Units</th>
                                        <th className="col-sm-2">Cost</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {rows}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-6 col-md-12">
                            <button
                                type="button"
                                className="btn btn-primary"
                                disabled={this.props.codeList.length >= this.props.maxCodes || !this.props.preReqsMet}
                                onClick={this.showAddCodeModal}
                            >Add CPT Code</button>
                        </div>
                        <div className="col-sm-6 col-md-12">
                            {!this.props.preReqsMet ? '* You must select an Insurance, Provider, and Location before adding procedure codes.' : ''}
                        </div>
                    </div>
                </div>
                <div className="modal fade" ref={this.addCodeModalRef} tabIndex="-1" role="dialog" aria-labelledby="Add Code Modal">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Add CPT Code</h5>
                                <button type="button" className="btn-close" onClick={this.hideAddCodeModal} aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <HfKendoComboBox
                                    id="addCodeComboBox"
                                    ref={this.addCodeModalInitFieldRef}
                                    delay={500}
                                    minLengthForSearch={3}
                                    api={Api.searchProcedures}
                                    dataItemKey="label"
                                    textField="label"
                                    onChange={this.handleCodeSelectionChange}
                                    style={{ width: "100%" }}
                                />
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={this.hideAddCodeModal}>Close</button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    disabled={!this.state.codeSelection}
                                    onClick={this.handleCodeAdd}
                                >Accept</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal fade" ref={this.chooseAdminCodeModalRef} tabIndex="-1" role="dialog" aria-labelledby="Choose Admin Code">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Choose Admin Code</h5>
                                <button type="button" className="btn-close" onClick={this.hideChooseAdminCodeModal} aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <div className="form-group">
                                    <div className="col-sm-10 col-sm-offset-1">
                                        Multiple admin codes were associated with this procedure code. Please select one below.
                                    </div>
                                </div>
                                {adminCodeButtons}
                                {adminCodeComment}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={this.hideChooseAdminCodeModal}>Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}